import { useState, useEffect, useRef, useCallback } from "react";

const SCROLL_THRESHOLD = 100;

export const useScrollManagement = () => {
  const [isUserAtBottom, setIsUserAtBottom] = useState(true);
  const [hasNewMessages, setHasNewMessages] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const messagesContainerRef = useRef<HTMLDivElement>(null);

  const checkIfAtBottom = useCallback(() => {
    const container = messagesContainerRef.current;
    if (!container) return true;
    
    const { scrollTop, scrollHeight, clientHeight } = container;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
    const atBottom = distanceFromBottom < SCROLL_THRESHOLD;
    
    console.log('[SCROLL] checkIfAtBottom:', { scrollTop, scrollHeight, clientHeight, distanceFromBottom, atBottom });
    return atBottom;
  }, []);

  const scrollToBottom = useCallback(() => {
    console.log('[SCROLL] scrollToBottom called');
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    setHasNewMessages(false);
    setIsUserAtBottom(true);
  }, []);

  useEffect(() => {
    const container = messagesContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const atBottom = checkIfAtBottom();
      setIsUserAtBottom(atBottom);
      
      if (atBottom && hasNewMessages) {
        console.log('[SCROLL] User scrolled to bottom, clearing hasNewMessages flag');
        setHasNewMessages(false);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [hasNewMessages, checkIfAtBottom]);

  return {
    isUserAtBottom,
    hasNewMessages,
    setHasNewMessages,
    messagesEndRef,
    messagesContainerRef,
    checkIfAtBottom,
    scrollToBottom,
  };
};
